module.exports = __webpack_public_path__ + "media/images/mobile/service/bg-aaad266d67f2fda31d180da62b19685c.png";